<div class="downloads-current-wrapper">
  @if (gettingDownloads) {
    <ebs-spinner [spinnerMessage]="'loading downloads'"></ebs-spinner>
  }

  <div class="table-responsive">
    <table class="table table-sm">
      <thead>
        <tr>
          <th>Module</th>
        </tr>
      </thead>
      <tbody>
        @if (showNoDownloadsMessage()) {
          <tr>
            <td> No current downloads </td>
          </tr>
        }
        @for (download of currentDownloads; track download) {
          <tr>
            <td style="width: 70%">{{download.number}} - {{download.name}}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (downloadsError) {
    <ebs-notification-multiple [notifications]="notifications"> </ebs-notification-multiple>
  }
</div>